import type { Industry } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

export const useAgentContext = (industry?: Industry) => {
  useRegisterAgentContext(
    industry
      ? {
          kind: 'entity',
          description: 'The industry the user is viewing',
          data: industry,
        }
      : null,
  );
};
